let phoneUtilPromise: Promise<import('google-libphonenumber').PhoneNumberUtil> | null = null;

export const isPhoneValidLazy = async (phone: string): Promise<boolean> => {
  try {
    phoneUtilPromise ??=
      import('google-libphonenumber').then(m => m.PhoneNumberUtil.getInstance());
    const phoneUtil = await phoneUtilPromise;
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch {
    return false;
  }
};
